import __request__ from "routing/request";
export function requestGet(path, hostname, requestOptions) {
  return __request__("GET", `/datanodes/${hostname}/opensearch/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestPut(path, hostname, requestOptions) {
  return __request__("PUT", `/datanodes/${hostname}/opensearch/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestPost(path, hostname, requestOptions) {
  return __request__("POST", `/datanodes/${hostname}/opensearch/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestDelete(path, hostname, requestOptions) {
  return __request__("DELETE", `/datanodes/${hostname}/opensearch/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
